import type { ChallengeWithCountsDto } from '@@types/api.types';
import { Tile } from '@components/shared/tile.component';
import { cn } from '@lib/utils';
import { EditIcon } from 'lucide-react';
import type { FC } from 'react';
import { useState } from 'react';
import { ChallengeModal, ChallengeModalStep } from './challenge-modal.component';
import { ChallengePhaseCard } from './challenge-phase-card.component';

type ChallengePhasesGridProps = {
  challenge: ChallengeWithCountsDto;
  className?: string;
};

export const ChallengePhasesGrid: FC<ChallengePhasesGridProps> = (props) => {
  const { challenge, className } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const hasPhases = challenge.phases && challenge.phases.length > 0;

  return (
    <>
      <Tile
        className={cn('w-full', className)}
        emptyState={{
          message: undefined,
          title: 'No Phases',
        }}
        header={{
          iconButton: {
            ariaLabel: 'Edit Challenge Phases',
            icon: <EditIcon />,
            onClick: () => setIsModalOpen(true),
          },
          title: 'Challenge Phases',
        }}
        hoverReveal
        isEmpty={!hasPhases}
      >
        <div className="flex flex-col gap-2 bg-gray-100 p-2 rounded-lg">
          {challenge.phases?.map((phase, index) => (
            <ChallengePhaseCard
              key={phase.id}
              matchCount={phase.matchCount}
              phase={phase}
              position={index + 1}
            />
          ))}
        </div>
      </Tile>

      {isModalOpen && (
        <ChallengeModal
          challenge={challenge}
          initialStep={ChallengeModalStep.PHASES}
          isEdit={true}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};
